import React, { Component } from 'react'; // eslint-disable-line
import { Draggable } from 'react-beautiful-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EditableLabel from '../forms/EditableLabel';
import Grabber from '../svg/Grabber';
import UserSelectedIconSelect from '../pages/UserSelectedIconSelect';

export class EditSortableMenuItem extends Component {
    constructor(props) {
        super(props);
        this.menuItemTitleChanged = this.menuItemTitleChanged.bind(this);
        this.menuItemChanged = this.menuItemChanged.bind(this);
        this.switchState = this.switchState.bind(this);
        this.getPlaceholder = this.getPlaceholder.bind(this);
        this.state = {
            inputEditState: false,
        };
    }

    getPlaceholder() {
        let placeholder = this.props.menuItemsMetadata
            .find((mt) => {
                return mt.Id.toString() === this.props.menuItem.subType;
            })?.Name;
        if (!placeholder) {
            const discoverId = this.props.modules?.data.find((mt) => {
                return mt.moduleType === 1;
            })?.pageId;
            placeholder = discoverId === this.props.menuItem.subType ? 'Discover' : 'Custom Page';
        }
        return placeholder;
    }

    menuItemTitleChanged(e) {
        if (e.target.value !== '') {
            this.props.menuItem.title = e.target.value;
            this.menuItemChanged('title', e.target.value);
        } else {
            this.props.menuItem.title = this.getPlaceholder().substring(0, 11);
            this.menuItemChanged('title', this.getPlaceholder().substring(0, 11));
        }
    }

    menuItemChanged(field, val) {
        if (this.props.onChange) {
            this.props.onChange(field, val, this.props.menuItem);
        }
    }

    switchState(state) {
        this.setState({ inputEditState: state });
    }

    render() {
        const {
            className,
            isOver,
        } = this.props;
        let cssClass = className;
        if (isOver) {
            cssClass = `${cssClass} sortable-ghost`;
        }
        const placeholder = this.getPlaceholder();
        return (
            <Draggable
                key={this.props.menuItem.$id}
                draggableId={this.props.menuItem.id}
                index={this.props.index}
            >
                {/* eslint-disable */}
                {(provided) => {
                    return (

                        <div className="menu-card">
                            <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                            >
                                <span key={this.props.menuItem.$id}>
                                    <div
                                        id={this.props.menuItem.id}
                                        className={`menuItem menuItem-on
                 ${(this.state.inputEditState ? 'edit-in-focus' : '')} ${cssClass}`}
                                    >
                                        {this.props.userSelectedIcons && <UserSelectedIconSelect id={this.props.menuItem.subType} type={this.props.menuItem.type} autoUpdate />}
                                        {!this.props.userSelectedIcons
                                            && (
                                                <span className="btn-design-system medium icon user-icon">
                                                    <FontAwesomeIcon
                                                        icon={['fal', this.props.menuItem.icon]}
                                                        color="#616B7D"
                                                    />
                                                </span>
                                            )}
                                        <EditableLabel
                                            placeholder={placeholder}
                                            maxChars={12}
                                            switchState={this.switchState}
                                            onChange={this.menuItemTitleChanged}
                                            value={this.props.menuItem ? this.props.menuItem.title : ''}
                                            menuTitle
                                        />
                                        <h4>
                                            {placeholder}
                                        </h4>
                                        <div className="menuItem__grabber"
                                            {...provided.dragHandleProps}>
                                            <Grabber />
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    );
                }}
            </Draggable>
        );
    }
}

export default EditSortableMenuItem;
